import { ValidationRules } from "@/models/Validation"

import { t } from "@/plugins/i18n";
export default interface AccountCodeEditModel {
    accountCodeId: number;
    columnDictionaryId: number;
    valueNat: string;
    tableName: string;
    columnName: string;
    accountCode: string;
    largeText: string;
    gridText: string;
    displayTableName: string;
    inEdit: boolean;
}

export const rules: ValidationRules = {
    accountCode: [
        (v: string) => !!v || t("Kotelezo"),
        (v: string) => v.length <= 10 ||t("AccountCodeEditModel_NemLehetHosszabbMint10Karakter")
    ],
    tableName: [
        (v: string) => !!v || t("Kotelezo"),
    ],
    columnName: [
        (v: string) => !!v || t("Kotelezo"),
    ]
}

export const accountCodeEditModelDefaultProps: AccountCodeEditModel = {
    accountCodeId: 0,
    columnDictionaryId: 0,
    valueNat: "",
    tableName: "",
    columnName: "",
    accountCode: "",
    largeText: "",
    gridText: "",
    displayTableName: "",
    inEdit: false,
}

export interface AccountCodeEditModelResponse {
    accountCodeEditModels: AccountCodeEditModel[];
    count: number;
}